import { IInitialFileState } from "@components/SocialPersonal/store";

export const getCurrentStep = (id: string, state: IInitialFileState): number => {
    if (id) {
        if (state.multipleFiles[id]?.front?.path) {
            return 0;
        } else if (state.multipleFiles[id]?.back?.path) {
            return 1;
        } else if (state.multipleFiles[id]?.selfie?.path) {
            return 2;
        }
    }

    return 0;
};
